// The call card in a chat (MessageResponse.call), from the viewer's side like the app's
// CallInfo.outcomeFor (app/.../call/CallInfo.kt) and its texts (ui/call/CallScreens.kt).

import type { CallResponse } from "../api/contract.gen.ts";
import { duration } from "../data/display.ts";

export interface CallCard {
  text: string;
  detail?: string;
  missed: boolean;
}

export function callCard(call: CallResponse, me: string | null, callbackName?: (id: string) => string): CallCard {
  const kind = call.kind === "video" ? "Videoanruf" : "Sprachanruf";
  const caller = call.started_by === me;
  const mine = call.participants.find((p) => p.user_id === me)?.state;
  let outcome: string;
  if (call.answered_at) {
    if (!caller && mine === "missed") outcome = "MISSED";
    else if (!caller && mine === "busy") outcome = "MISSED_BUSY";
    else if (!caller && mine === "declined") outcome = "DECLINED_BY_ME";
    else outcome = call.end_reason === "failed" ? "FAILED" : "TALKED";
  } else {
    const r = call.end_reason;
    if (r === "declined") outcome = caller ? "DECLINED" : "DECLINED_BY_ME";
    else if (r === "busy") outcome = caller ? "BUSY" : "MISSED_BUSY";
    else if (r === "no_answer") outcome = caller ? "NO_ANSWER" : "MISSED";
    else if (r === "failed") outcome = "FAILED";
    else outcome = caller ? "CANCELLED" : "MISSED";
  }
  const texts: Record<string, string> = {
    TALKED: caller ? `Ausgehender ${kind}` : `Eingehender ${kind}`,
    MISSED: `Verpasster ${kind}`,
    MISSED_BUSY: `Verpasster ${kind} (besetzt)`,
    DECLINED_BY_ME: `Abgelehnter ${kind}`,
    NO_ANSWER: `${kind} · keine Antwort`,
    DECLINED: `${kind} · abgelehnt`,
    BUSY: `${kind} · besetzt`,
    CANCELLED: `${kind} · abgebrochen`,
    FAILED: `${kind} · nicht möglich`,
  };
  let detail = outcome === "TALKED" && call.duration_s ? duration(call.duration_s * 1000) : undefined;
  if (call.callback_at) {
    const at = new Date(call.callback_at);
    const today = at.toDateString() === new Date().toDateString();
    const time = at.toLocaleTimeString("de-AT", { hour: "2-digit", minute: "2-digit" });
    const when = today ? time : `${at.toLocaleDateString("de-AT", { weekday: "short" })} ${time}`;
    detail = call.callback_by === me ? `Du rufst um ${when} zurück` : `Ruft dich um ${when} zurück`;
    void callbackName;
  }
  return { text: texts[outcome]!, detail, missed: outcome === "MISSED" || outcome === "MISSED_BUSY" };
}
